export class AdminForm {

    email:string = "";

    confirmEmail: string = "";

    canAdministrate: boolean = false;

    canCreate: boolean = false;

    canModerate: boolean = false;
}


// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./~/tslint-loader?{"configFile":"tslint.json"}!./src/app/components/admin/admin-form.model.ts